import { render, staticRenderFns } from "./OrderPreview.vue?vue&type=template&id=740b2555&scoped=true&"
import script from "./OrderPreview.vue?vue&type=script&lang=js&"
export * from "./OrderPreview.vue?vue&type=script&lang=js&"
import style0 from "./OrderPreview.vue?vue&type=style&index=0&id=740b2555&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b2555",
  null
  
)

export default component.exports